import type { Theme } from '@mui/material';

const customShadows = (): Theme['customShadows'] => {
  const color = `var(--mui-palette-mainShadowChannel)`;
  return {
    xs: `0px 2px 4px rgb(${color} / 0.18)`,
    sm: `0px 3px 6px rgb(${color} / 0.2)`,
    md: `0px 4px 10px rgb(${color} / 0.22)`,
    lg: `0px 6px 16px rgb(${color} / 0.24)`,
    xl: `0px 8px 28px rgb(${color} / 0.26)`,
  };
};

export default customShadows;
